import { parseJson } from "./connection";

/**
 * Ticket domain helpers for shared realtime.
 * Does NOT own the WebSocket lifecycle.
 */

export function extractLiveTicket(payload) {
  const root = parseJson(payload);
  const data = parseJson(root && root.data != null ? root.data : root);
  const candidates = [
    data && data.ticket,
    data && data.data && data.data.ticket,
    data && data.data,
    data,
  ];
  for (let i = 0; i < candidates.length; i++) {
    const item = parseJson(candidates[i]);
    if (!item || typeof item !== "object") {
      continue;
    }
    const id = item.id != null ? item.id : item.ticket_id || item.ticketId;
    if (id != null) {
      return Object.assign({}, item, { id });
    }
  }
  return null;
}

export function isTicketChannel(payload) {
  const channel = String((payload && payload.channel) || "").toLowerCase();
  const eventName = String((payload && payload.event) || "");
  if (channel.indexOf("chat.") === 0) {
    return false;
  }
  if (channel === "ticket" || channel.indexOf("ticket") !== -1) {
    return true;
  }
  return eventName.indexOf("Ticket") !== -1 && eventName.indexOf("Message") === -1;
}

export function isMessageChannel(payload) {
  const channel = String((payload && payload.channel) || "").toLowerCase();
  const eventName = String((payload && payload.event) || "");
  if (channel.indexOf("chat.") === 0) {
    return false;
  }
  if (channel === "message" || channel.indexOf("message") !== -1) {
    return true;
  }
  return eventName.indexOf("Message") !== -1;
}

export function extractTicketSummary(payload) {
  const root = parseJson(payload);
  const data = parseJson(root && root.data != null ? root.data : root);
  const candidates = [
    data && data.summary,
    data && data.data && data.data.summary,
    data && data.counts,
    data && data.data && data.data.counts,
    data,
  ];
  for (let i = 0; i < candidates.length; i++) {
    const item = parseJson(candidates[i]);
    if (!item || typeof item !== "object") {
      continue;
    }
    const rawNew =
      item.new != null
        ? item.new
        : item.new_count != null
          ? item.new_count
          : item.newCount;
    if (rawNew == null || Array.isArray(item) || item.id != null) {
      continue;
    }
    const numeric = Number(rawNew);
    if (isNaN(numeric)) {
      continue;
    }
    return Object.assign({}, item, { new: numeric });
  }
  return null;
}

export function extractTicketMessage(payload) {
  const data = payload && payload.data != null ? payload.data : payload;
  if (!data || typeof data !== "object") {
    return { ticketId: null, message: null };
  }
  const nested =
    data.data && typeof data.data === "object"
      ? data.data
      : data.message && typeof data.message === "object"
        ? data.message
        : data;
  const ticketId =
    nested.ticket_id ||
    nested.ticketId ||
    (nested.ticket && nested.ticket.id) ||
    data.ticket_id ||
    data.ticketId ||
    (data.ticket && data.ticket.id) ||
    null;
  return { ticketId, message: nested };
}

/**
 * Subscribe ticket + message channels on an existing realtime connection.
 * @returns {Function} unsubscribe
 */
export function subscribeTicketChannels(realtime) {
  if (!realtime || typeof realtime.subscribe !== "function") {
    return function () {};
  }
  realtime.subscribe("ticket");
  realtime.subscribe("message");
  return function unsubscribe() {
    realtime.unsubscribe("ticket");
    realtime.unsubscribe("message");
  };
}
